import styled from "styled-components";

export const BannerSection = styled.section`
  width: 100%;
  height: 100%;
  .bannerLink {
    height: 100%;
  }
  .banner {
    position: relative;
    height: 100%;
    max-height: 350px;
    z-index: -10;
    border-radius: 10px;
    overflow: hidden;
    font-family: "Open Sans", sans-serif;
    display: grid;
    grid-template-columns: 55% 1fr;
  }

  .svg {
    position: absolute;
    height: 100%;
    max-width: 100%;
    width: auto;
    z-index: -1;
    right: 0;
  }

  .textArea {
    box-sizing: border-box;
    left: 0;
    height: 100%;
    width: auto;
    display: flex;
    align-items: center;
    position: relative;
  }

  .textArea > p {
    box-sizing: border-box;
    padding: 14px;
    overflow: hidden;
    width: 94%;
    text-align: left;
    color: white;
    text-decoration: none;
    font-size: calc(13px + 1vw);
    line-height: calc(15px + 1.2vw);
    margin: 0;
    @media screen and (max-height: 500px) {
      font-size: calc(9px + 1vw);
      line-height: calc(5px + 1.2vw);
    }
  }

  .banner__image {
    object-fit: cover;
    object-position: top center;
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 60%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: -2;
    @media screen and (min-width: 1280px) {
      object-position: 50% 15%;
      max-width: 50%;
    }
  }
`;

export const Yellow = styled.span`
  color: #fcde17;
  font-weight: 700;
`;

export const Flag = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #FCDE17;
  color: #000000;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  z-index: 10;
  font-family: "Open Sans", sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  @media screen and (max-width: 768px) {
    font-size: 10px;
    padding: 6px 12px;
  }
`;
